import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e289b38")

_pushScopeId("data-v-3e289b38")
const _hoisted_1 = { class: "profile" }
const _hoisted_2 = { class: "edit" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SignInAccount = _resolveComponent("SignInAccount")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_SignInAccount, {
        class: "account",
        userName: _ctx.auth.displayName,
        email: _ctx.auth.email,
        avatar: _ctx.auth.picture,
        isProfile: true
      }, null, 8, ["userName", "email", "avatar"])
    ])
  ]))
})